import {
  Button,
  Flex,
  Heading,
  // Link,
  Stack,
  Text,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import { formatPrice } from './PriceTag'
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {doPaymentProcess} from "../../../redux/waiver/waiver.actions.js";

const OrderSummaryItem = (props) => {
  // eslint-disable-next-line react/prop-types
  const { label, value, children } = props
  return (
    <Flex justify="space-between" fontSize="sm">
      <Text fontWeight="medium" color={mode('gray.600', 'gray.400')}>
        {label}
      </Text>
      {value ? <Text fontWeight="medium">{value}</Text> : children}
    </Flex>
  )
}

export const CartOrderSummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {orderSummary={}, minor=[], major={}, loadingWaiver} = useSelector(s => s?.waiver)
  const handlePayment = () => {
    const payload = {
      email:major?.email ?? '',
      parentCode: major?.id ?? '',
      major,
      minor,
      orderSummary,
      isMember:'1',
      brand: localStorage.getItem('brand') ?? ''
    }
    dispatch(doPaymentProcess(payload, navigate))
  }

  return (
    <Stack spacing="8" borderWidth="1px" rounded="lg" padding="8" width="full">
      <Heading size="md">Order Summary</Heading>

      <Stack spacing="6">
        <OrderSummaryItem label="Subtotal" value={formatPrice(orderSummary?.subTotal ?? 0)} />
        <OrderSummaryItem label="Transaction Fee" value={formatPrice(0)} />

        {/*<OrderSummaryItem label="Coupon Code">*/}
        {/*  <Link href="#" textDecor="underline">*/}
        {/*    Add Discount*/}
        {/*  </Link>*/}
        {/*</OrderSummaryItem>*/}
        <Flex justify="space-between">
          <Text fontSize="lg" fontWeight="semibold">
            Total (incl. Tax)
          </Text>
          <Text fontSize="xl" fontWeight="extrabold">
            {formatPrice(orderSummary?.subTotal ?? 0)}
          </Text>
        </Flex>
      </Stack>
      <Button colorScheme="blue" size="lg" fontSize="md" onClick={handlePayment} isDisabled={(orderSummary?.subTotal ?? 0) === 0} isLoading={loadingWaiver}>
        Payment {formatPrice(orderSummary?.subTotal ?? 0)}
      </Button>
    </Stack>
  )
}